import {
  googleAdsConnectedNumberConversion,
  googleAdsSignupConversion,
  googleAdsSubscribeConversion,
  googleAdsWebsiteSaleConversion,
  monthlyPaymentPerLine,
} from "../../constants.ts";
import { capturePosthog, identifyPosthog } from "./analytics.ts";

declare global {
  function gtag(
    command: string,
    targetOrEvent: string | Date,
    params?: Record<string, string | number | boolean | undefined>,
  ): void;
}

const isStorageAvailable = typeof localStorage !== "undefined";

const isAlreadyTracked = (key: string) => {
  if (!isStorageAvailable) return false;
  return localStorage.getItem(key) !== null;
};

const markAsTracked = (key: string) => {
  if (!isStorageAvailable) return;
  localStorage.setItem(key, "1");
};

export const trackSignUpConversion = (email?: string) => {
  const dedupeKey = email ? `sg_conv_signup_${email}` : "sg_conv_signup";
  if (isAlreadyTracked(dedupeKey)) return;
  markAsTracked(dedupeKey);

  if (typeof gtag !== "undefined") {
    gtag("event", "sign_up", { method: "magic_code" });
    gtag("event", "conversion", {
      send_to: googleAdsSignupConversion,
    });
  }

  if (email) {
    identifyPosthog(email);
    capturePosthog("User Signed Up", { email });
  }
};

export const trackConnectedNumberConversion = (phoneNumber: string) => {
  if (!phoneNumber) return;
  const dedupeKey = `sg_conv_conn_${phoneNumber}`;
  if (isAlreadyTracked(dedupeKey)) return;
  markAsTracked(dedupeKey);

  if (typeof gtag !== "undefined") {
    gtag("event", "conversion", {
      send_to: googleAdsConnectedNumberConversion,
    });
  }

  capturePosthog("WhatsApp Account Connected", { phoneNumber });
};

export type PurchaseConversionParams = {
  value?: number;
  currency?: string;
  transactionId?: string;
};

export const trackPurchaseConversion = ({
  value = monthlyPaymentPerLine,
  currency = "USD",
  transactionId,
}: PurchaseConversionParams = {}) => {
  const dedupeKey = transactionId
    ? `sg_conv_paid_${transactionId}`
    : `sg_conv_paid_${Date.now()}`;
  if (isAlreadyTracked(dedupeKey)) return;
  markAsTracked(dedupeKey);

  if (typeof gtag !== "undefined") {
    gtag("event", "purchase", {
      transaction_id: transactionId,
      value,
      currency,
    });
    gtag("event", "conversion", {
      send_to: googleAdsWebsiteSaleConversion,
      value,
      currency,
      transaction_id: transactionId,
    });
    gtag("event", "conversion", {
      send_to: googleAdsSubscribeConversion,
      value,
      currency,
      transaction_id: transactionId,
    });
  }

  capturePosthog("Subscription Purchased", {
    value,
    currency,
    transaction_id: transactionId || "",
  });
};
